import config from '../../../common/utils/constants/config';

export const mapStyleTypes = {
  satellite: 'satellite',
  streets: 'streets',
  hybrid: 'hybrid',
};

export const mapStyles = {
  [mapStyleTypes.streets]: {
    id: mapStyleTypes.streets,
    name: 'Streets',
    url: config.POI_STREETS_STYLE_URL,
  },
  [mapStyleTypes.satellite]: {
    id: mapStyleTypes.satellite,
    name: 'Satellite',
    url: config.POI_SATELLITE_STYLE_URL,
  },
  [mapStyleTypes.hybrid]: {
    id: mapStyleTypes.hybrid,
    name: 'Hybrid',
    url: config.POI_HYBRID_STYLE_URL,
  },
};

export default mapStyles;
